import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, createMigrate, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage";

import rootReducer from "src/reducers";
import axoisInterceptor from 'src/utils/axios_interceptors'

const migrations = {
    // v2 -- permissions. Anything persisted before the permission model carries a
    // loggedIn with no permissions array. Drop the identity (not the rest of the
    // tree) so the app re-reads /admin/auth/me instead of trusting a pre-RBAC
    // shape. Bumping "version" alone does NOT purge: redux-persist's default
    // migrate is a pass-through, so the explicit migrate below is what does it.
    2: (state) => ({
        ...state,
        core: {
            ...(state?.core || {}),
            loggedIn: null,
            permissions: [],
            permissionsLoaded: false,
        },
    }),
};

const persistConfig = {
    key: "admin",
    version: 2,
    storage,
    migrate: createMigrate(migrations, { debug: false }),
    // Support tickets are a live conversation, not settings. Rehydrating last
    // session's thread would paint a stale ticket -- old status, old messages,
    // an already-answered "needs reply" -- and hold it there until the first
    // fetch lands. Always fetch it fresh.
    blacklist: ["supportTickets"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

axoisInterceptor(store)

export default store;
